import React from 'react';
import {
  Crate,
  CrateProps,
  Badge,
  FlexCrate,
  Icon,
  Text,
} from '@perch-labs/shrike';
import { formatAsMoney, formatDate } from '@perch-labs/warbler';
import { copyFor } from 'config';
import { LineThrough } from './total-due.style';

export interface TotalDueProps extends CrateProps {
  directPaymentToDeveloper?: boolean;
  paymentDate?: string;
  paymentDescription?: string;
  status?: StatementStatus;
  total: number;
  totalBeforeSolarSavings: number;
  headlineSolarSavingsRate: number | null;
}
const getCopy = copyFor('billing.statement.totalDue');

// TODO: do we want more than just chargedAt and scheduledAt copy?

export const TotalDue = ({
  directPaymentToDeveloper,
  paymentDate,
  paymentDescription,
  status,
  total,
  totalBeforeSolarSavings,
  headlineSolarSavingsRate,
  ...crateProps
}: TotalDueProps) => {
  // TODO: compute further up
  const solarSavingsAmount = totalBeforeSolarSavings - total;
  const hasSolarSavings = !!solarSavingsAmount;

  return (
    <Crate {...crateProps}>
      <Text
        textStyle="heading500"
        tag="h2"
        color="secondary"
        margin={{ top: '24px' }}
      >
        {!directPaymentToDeveloper
          ? getCopy('title')
          : getCopy('titleForDeveloperPayment')}
      </Text>
      <Text textStyle="heading900" margin={{ top: '12px' }}>
        {formatAsMoney(total, { conversion: 'fromCents' })}
      </Text>
      {hasSolarSavings && (
        <>
          <LineThrough>
            {formatAsMoney(totalBeforeSolarSavings, {
              conversion: 'fromCents',
            })}
          </LineThrough>
          <Badge
            backgroundColor="accent3"
            color="primary"
            margin={{ top: '8px' }}
          >
            <FlexCrate alignItems="center">
              <Icon
                icon="CheckmarkCircleInverted"
                margin={{ right: '8px' }}
                aria-hidden={true}
              />
              {headlineSolarSavingsRate
                ? getCopy('badge.applied', {
                    percent: headlineSolarSavingsRate,
                  })
                : getCopy('badge.appliedWithoutPercent')}
            </FlexCrate>
          </Badge>
        </>
      )}
      {paymentDescription && paymentDate && (
        <Text color="primary" margin={{ top: '16px' }} textStyle="paragraph400">
          {getCopy(status === 'paid' ? 'chargedAt' : 'scheduledAt', {
            paymentMethodCopy: paymentDescription,
            date: formatDate(paymentDate, { format: 'MMM d, yyyy' }),
          })}
        </Text>
      )}
    </Crate>
  );
};
